import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminCarsApi } from "../../http/cars/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarDialogProps = {
  carId: string;
  onClose: () => void;
};

const DeleteCarDialog: FC<DeleteCarDialogProps> = ({ carId, onClose }) => {
  const i18n = useI18n();
  const carsApi = useAdminCarsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.cars.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            carsApi
              .deleteCar(carId)
              .then(() => {
                dispatch(showSuccessNotification(i18n.t));
                onClose();
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.cars.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarDialog;
